"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
Parse objects passed to the logger and map to JSON
*/
const EOL = "\n";
/**
 * Format a message. Mixin that returns the formatted message
 *
 * @param {any} obj The message object
 * @returns {WithWildcards<ParseResponse>} parsed response
*/
function parse(obj) {
    if (typeof obj === "function") {
        obj = obj();
    }
    let out = {
        status: null,
        stack: "",
        name: "",
        message: "",
        source: "",
    };
    // simple log format
    if (typeof obj === "string" || typeof obj === "number") {
        out.message = String(obj);
    }
    else if (obj instanceof Error) {
        const errorWildcards = obj;
        const { id, message, stack, name, statusCode, source } = errorWildcards, rest = __rest(errorWildcards, ["id", "message", "stack", "name", "statusCode", "source"]);
        Object.assign(out, {
            id,
            message,
            stack,
            name,
            status: statusCode || null,
            source: source || ""
        }, rest);
        Object.assign(out, {
            id,
            message,
            stack,
            name,
            status: statusCode || null,
            source: source || "",
        }, rest);
    }
    else {
        if (obj) {
            if (obj.message) {
                Object.assign(out, obj);
            }
            else if (obj.level) {
                out.source = "express";
                out.level = obj.level;
                out.messageJson = obj;
            }
            else {
                out.message = JSON.stringify(obj, null, 2);
            }
        }
    }
    out.message = normalizeEndings(out.message);
    out.stack = normalizeEndings(out.stack);
    const { userId, activityId, routeTemplate } = obj || {};
    if (userId !== undefined)
        out.userId = userId;
    if (activityId !== undefined)
        out.activityId = activityId;
    if (routeTemplate !== undefined)
        out.routeTemplate = routeTemplate;
    return out;
}
function normalizeEndings(text) {
    if (!text)
        return "";
    text = text.replace(/\r\n/g, "\n");
    text = text + "\n";
    text = text.replace(/[\n]{2,}/g, "\n");
    text = text.replace(/\n/g, EOL);
    while (text.endsWith(EOL)) {
        text = text.substring(0, text.length - EOL.length);
    }
    return text;
}
exports.default = parse;
//# sourceMappingURL=input-parser.js.map